import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { useContext, useEffect, useState } from 'react';
import { Table } from './FeatureStyledComponents';
import FeaturesLimitedTableRows from './FeaturesLimitedTableRows';
import { debounce } from '../../utils';
import { AllProductLines } from 'self-service-api/constants/ProductLines';
import { FeaturesContext } from './FeaturesProvider';

const FeaturesSuiteTable = () => {
  const {
    highlightedProducts
  } = useContext(FeaturesContext);
  const [width, setWidth] = useState(window.innerWidth);
  useEffect(() => {
    const resizeWindow = debounce(() => setWidth(window.innerWidth), 250);
    window.addEventListener('resize', resizeWindow);
    return () => window.removeEventListener('resize', resizeWindow);
  }, []);
  const currentProduct = highlightedProducts[0];
  return /*#__PURE__*/_jsx(Table, {
    children: /*#__PURE__*/_jsx("tbody", {
      children: /*#__PURE__*/_jsx(FeaturesLimitedTableRows, {
        activeColumn: 0,
        currentProduct: currentProduct,
        showTooltip: width >= 800
      })
    })
  });
};

FeaturesSuiteTable.propTypes = {
  productLine: PropTypes.oneOf(AllProductLines).isRequired
};
export default FeaturesSuiteTable;